import { fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { logout } from "../store/authSlice";
import toast from "react-hot-toast";

const customBaseQuery = fetchBaseQuery({
  baseUrl: import.meta.env.VITE_BASE_SERVER_URL,
  timeout: 120000, // 2 minutes timeout for large data requests
  prepareHeaders: (headers, api) => {
    const token = api.getState().auth?.token;
    if (token) {
      headers.set("Authorization", token);
    }
    // Add headers for large data handling
    headers.set("Accept", "application/json");
    headers.set("Content-Type", "application/json");
  },
});

export const baseQueryWithAccessKey = async (args, api, extraOptions) => {
  // Remove token from query params for GET requests
  if (args.method?.toLowerCase() !== "post") {
    const token = api.getState().auth?.token;
    // Don't add access_key to params anymore since we're using headers
    args.params = { ...args.params };
  }

  // Override timeout for specific requests if provided
  if (args.timeout) {
    extraOptions = { ...extraOptions, timeout: args.timeout };
  }

  // console.log("Making API request:", {
  //   url: args.url,
  //   method: args.method || "GET",
  //   params: args.params,
  //   timeout: args.timeout || 120000,
  // });

  const result = await customBaseQuery(args, api, extraOptions);

  // console.log("API request completed:", {
  //   url: args.url,
  //   success: !result.error,
  //   error: result.error?.status,
  //   dataSize: result.data ? JSON.stringify(result.data).length : 0,
  // });

  if ("error" in result && result.error?.status === 504) {
    toast.error(
      result?.error.data?.[0] || "Session expired, please login again",
      {
        duration: 5000,
      }
    );
    api.dispatch(logout());
  }

  // Handle timeout errors
  if (
    "error" in result &&
    (result.error?.status === 408 || result.error?.name === "TimeoutError")
  ) {
    toast.error(
      "Request timed out. The data is large and may take longer to load.",
      {
        duration: 8000,
      }
    );
  }

  return result;
};
